<template>
  <div id="app" class="flex overflow-hidden">
    <nav-bar v-if="logged && site && site._id" class="shadow-sm"></nav-bar>
    <div
      class="w-full flex overflow-auto bg-baby-purple mt-[70px] lg:mt-0"
      @click="clickOut"
    >
      <transition name="fade" mode="out-in">
        <router-view class="z-[1]" />
      </transition>
      <footer />
    </div>

    <transition name="fade" mode="out-in">
      <div
        class="fixed w-full h-full bg-dark-purple-75 flex items-center justify-center p-0-0-0-0 z-[8000]"
        v-if="loading.active"
      >
        <inline-svg
          src="/images/rings.svg"
          width="180px"
          height="180px"
          fill="white"
          aria-label="Loading..."
        />
      </div>
    </transition>
    <transition-expanded>
      <notifications-toast class="z-[9000]" v-if="notifications.active" />
    </transition-expanded>
    <transition name="fade" mode="out-in">
      <klaus-modal
        :data="{ component: 'div', classes: ['bg-dark-purple-75 z-[2]'] }"
        v-if="modal.active"
      >
        <klaus-painter v-if="modal.active" :data="modal.content" />
      </klaus-modal>
    </transition>
  </div>
</template>
<script>
import NavBar from "@/components/UI/NavBar.vue"

import "@/styles/global.scss"
import "@/styles/multiselect.scss"

import "@/styles/index.css"

import { mapActions, mapGetters } from "vuex"

export default {
  components: {
    NavBar,
    "klaus-painter": () => import("@/components/UI/Painter/KlausPainter"),
    "notifications-toast": () => import("@/components/UI/NotificationsToast"),
    "transition-expanded": () => import("@/components/TransitionExpanded"),
    "klaus-modal": () => import("@/components/UI/Painter/KlausModal")
  },
  methods: {
    ...mapActions(["UPDATE_general", "FETCH_zones"]),

    clickOut() {
      this.UPDATE_general({
        param: "menuMobile",
        key: "toggle",
        value: false
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener(
        "focus",
        /*  */
        () =>
          this.UPDATE_general({
            param: "window",
            key: "focused",
            value: true
          })
      )
      window.addEventListener(
        "blur",
        /*  */
        () =>
          this.UPDATE_general({
            param: "window",
            key: "focused",
            value: false
          })
      )
    })
  },
  beforeDestroy() {
    window.removeEventListener(
      "focus",
      /*  */
      () =>
        this.UPDATE_general({
          param: "window",
          key: "focused",
          value: true
        })
    )
    window.removeEventListener(
      "blur",
      /*  */
      () =>
        this.UPDATE_general({
          param: "window",
          key: "focused",
          value: false
        })
    )
  },
  computed: {
    ...mapGetters([
      "loading",
      "modal",
      "logged",
      "notifications",
      "site",
      "count"
    ])
  },
  watch: {}
}
</script>
